/**
 * Libs Service - Main Entry Point
 * 
 * Cung cấp API client system hoàn chỉnh với:
 * - HTTP client với token refresh tự động
 * - React hooks cho data fetching và mutations
 * - Server-side helpers cho server actions
 * - Environment configuration
 * - Authentication utilities
 */

// API Client System
export * from './api';

// Configuration
export * from './config';
